import { render, staticRenderFns } from "./SurgDotsMenu.vue?vue&type=template&id=52b4256a&scoped=true"
import script from "./SurgDotsMenu.vue?vue&type=script&lang=js"
export * from "./SurgDotsMenu.vue?vue&type=script&lang=js"
import style0 from "./SurgDotsMenu.vue?vue&type=style&index=0&id=52b4256a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b4256a",
  null
  
)

export default component.exports